import React from 'react'

import Header from "../componets/Header";
import Footer from "../componets/Footer";

import Banner from '../componets/resource/Banner'
import Stakeholder from '../componets/resource/Stakeholder'
import Faq from '../componets/resource/Faq'

const page = () => {
    return (
        <>
            <div className="">
                <Header/>
                <Banner />
                <Stakeholder/>
                <Faq/>
                <Footer/>
            </div>
        </>
    )
}

export default page